<template>
  <tr>
    <td data-label="Name">
      {{ esmTemplate.name }}
    </td>
    <td class="button-2 text-center">
      <button class="my-2 btn btn-warning" @click="editEsmTemplate()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteEsmTemplate()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'EsmTemplateRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      esmTemplate () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      editEsmTemplate () {
        this.$emit('edit', { permalink: 'editEsmTemplate', uuid: this.esmTemplate.uuid })
      },
      deleteEsmTemplate () {
        this.$emit('deleteObject', { permalink: 'deleteEsmTemplate', uuid: this.esmTemplate.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/EsmTemplate.vue